import {
    CREATE_BRANCH_FAIL,
    CREATE_BRANCH_SUCCESS,
    DELETE_BRANCH_FAIL,
    DELETE_BRANCH_SUCCESS,
    GET_BRANCH_LISTING_FAIL,
    GET_BRANCH_LISTING_SUCCESS,
    REQUEST_SINGPASS_FAIL,
    REQUEST_SINGPASS_SUCCESS,
    RESET_BRANCH_ACTION_STATE,
    RESET_BRANCH_STATE,
    UPDATE_BRANCH_FAIL,
    UPDATE_BRANCH_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    erpListing: [],
    erpDetails: [],
    branchListing: [],
    branchRemarkListing: [],
    branchInquiryListing: [],
    branchDetails: [],
    branchInterestRate: [],
    branchAdd: [],
    branchEdit: [],
    branchBulkEdit: [],
    branchRequestMakeModel: [],
    branchDelete: [],
    singpassRes: [],
    error: [],
}

const Branch = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_BRANCH_LISTING_SUCCESS:
            return {
                ...state,
                branchListing: action.payload
            }
        case GET_BRANCH_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case CREATE_BRANCH_SUCCESS:
            return {
                ...state,
                branchAdd: action.payload
            }
        case CREATE_BRANCH_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_BRANCH_SUCCESS:
            return {
                ...state,
                branchEdit: action.payload
            }
        case UPDATE_BRANCH_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_BRANCH_SUCCESS:
            return {
                ...state,
                branchDelete: action.payload
            }
        case DELETE_BRANCH_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_BRANCH_ACTION_STATE:
            return {
                ...state,
                branchAdd: [],
                branchEdit: [],
                branchDelete: [],
                error: [],
            }
        case RESET_BRANCH_STATE:
            return {
                ...state,
                branchListing: [],
                branchAdd: [],
                branchEdit: [],
                branchDelete: [],
                error: [],
            }
        default:
            return state
    }
}

export default Branch
